"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var LogEvent_1 = __importDefault(require("./LogEvent"));
var StatsigNetwork_1 = require("./StatsigNetwork");
var Constants_1 = require("./utils/Constants");
var StatsigLocalStorage_1 = __importDefault(require("./utils/StatsigLocalStorage"));
var INTERNAL_EVENT_PREFIX = 'statsig::';
var CONFIG_EXPOSURE_EVENT = INTERNAL_EVENT_PREFIX + 'config_exposure';
var LAYER_EXPOSURE_EVENT = INTERNAL_EVENT_PREFIX + 'layer_exposure';
var GATE_EXPOSURE_EVENT = INTERNAL_EVENT_PREFIX + 'gate_exposure';
var LOG_FAILURE_EVENT = INTERNAL_EVENT_PREFIX + 'log_event_failed';
var DEFAULT_VALUE_WARNING = INTERNAL_EVENT_PREFIX + 'default_value_type_mismatch';
var MS_RETRY_LOGS_CUTOFF = 5 * 24 * 60 * 60 * 1000;
var MAX_BATCHES_TO_RETRY = 100;
var MAX_FAILED_EVENTS = 1000;
var MAX_LOCAL_STORAGE_SIZE = 1024 * MAX_FAILED_EVENTS;
var StatsigLogger = /** @class */ (function () {
    function StatsigLogger(options, identity, network, errorBoundary) {
        var _this = this;
        this._failedLogEventCount = 0;
        this.logConfigDefaultValueFallback = function (user, message, metadata) {
            var defaultValueEvent = (0, LogEvent_1.default)(DEFAULT_VALUE_WARNING, user, _this._identity._statsigMetadata, message, metadata);
            _this.log(defaultValueEvent);
            _this._loggedErrors.add(message);
        };
        this._options = options;
        this._identity = identity;
        this._network = network;
        this._errorBoundary = errorBoundary;
        this._queue = [];
        this._flushInterval = null;
        this._loggedErrors = new Set();
        this._failedLogEvents = [];
        this._exposureDedupeKeys = {};
        this._failedLogEventCount = 0;
        this._init();
    }
    StatsigLogger.prototype.log = function (event) {
        try {
            if (!this._options.disableCurrentPageLogging &&
                typeof window !== 'undefined' &&
                window != null &&
                typeof window.location === 'object' &&
                typeof window.location.href === 'string') {
                // https://stackoverflow.com/questions/6257463/how-to-get-the-url-without-any-parameters-in-javascript
                var parts = window.location.href.split(/[?#]/);
                if ((parts === null || parts === void 0 ? void 0 : parts.length) > 0) {
                    event.statsigMetadata.currentPage = parts[0];
                }
            }
        }
        catch (_e) { }
        this._queue.push(event);
        if (this._queue.length >= this._options.loggingBufferMaxSize) {
            this.flush();
        }
    };
    StatsigLogger.prototype.resetDedupeKeys = function () {
        this._exposureDedupeKeys = {};
    };
    StatsigLogger.prototype.logGateExposure = function (user, gateName, gateValue, ruleID, secondaryExposures, details, isManualExposure) {
        var dedupeKey = gateName + String(gateValue) + ruleID + details.reason;
        if (!this._shouldLogExposure(dedupeKey)) {
            return;
        }
        var metadata = {
            gate: gateName,
            gateValue: String(gateValue),
            ruleID: ruleID,
            reason: details.reason,
            time: details.time,
        };
        if (isManualExposure) {
            metadata['isManualExposure'] = 'true';
        }
        var gateExposure = (0, LogEvent_1.default)(GATE_EXPOSURE_EVENT, user, this._identity._statsigMetadata, null, metadata, secondaryExposures);
        this.log(gateExposure);
    };
    StatsigLogger.prototype.logConfigExposure = function (user, configName, ruleID, secondaryExposures, details, isManualExposure) {
        var dedupeKey = configName + ruleID + details.reason;
        if (!this._shouldLogExposure(dedupeKey)) {
            return;
        }
        var metadata = {
            config: configName,
            ruleID: ruleID,
            reason: details.reason,
            time: details.time,
        };
        if (isManualExposure) {
            metadata['isManualExposure'] = 'true';
        }
        var configExposure = (0, LogEvent_1.default)(CONFIG_EXPOSURE_EVENT, user, this._identity._statsigMetadata, null, metadata, secondaryExposures);
        this.log(configExposure);
    };
    StatsigLogger.prototype.logLayerExposure = function (user, configName, ruleID, secondaryExposures, allocatedExperiment, parameterName, isExplicitParameter, details, isManualExposure) {
        var dedupeKey = [
            configName,
            ruleID,
            allocatedExperiment,
            parameterName,
            String(isExplicitParameter),
            details.reason,
        ].join('|');
        if (!this._shouldLogExposure(dedupeKey)) {
            return;
        }
        var metadata = {
            config: configName,
            ruleID: ruleID,
            allocatedExperiment: allocatedExperiment,
            parameterName: parameterName,
            isExplicitParameter: String(isExplicitParameter),
            reason: details.reason,
            time: details.time,
        };
        if (isManualExposure) {
            metadata['isManualExposure'] = 'true';
        }
        var configExposure = (0, LogEvent_1.default)(LAYER_EXPOSURE_EVENT, user, this._identity._statsigMetadata, null, metadata, secondaryExposures);
        this.log(configExposure);
    };
    StatsigLogger.prototype.shutdown = function () {
        if (this._flushInterval) {
            clearInterval(this._flushInterval);
            this._flushInterval = null;
        }
        this.flush(true);
    };
    StatsigLogger.prototype.flush = function (isClosing) {
        var _this = this;
        if (isClosing === void 0) { isClosing = false; }
        if (this._queue.length === 0) {
            return;
        }
        var statsigMetadata = this._identity._statsigMetadata;
        var oldQueue = this._queue;
        this._queue = [];
        if (isClosing &&
            !this._network.supportsKeepalive() &&
            typeof navigator !== 'undefined' &&
            navigator != null &&
            // @ts-ignore
            navigator.sendBeacon) {
            var beacon = this._network.sendLogBeacon({
                events: oldQueue,
                statsigMetadata: statsigMetadata,
            });
            if (!beacon) {
                this._queue = oldQueue.concat(this._queue);
                if (this._queue.length > 0) {
                    this._addFailedRequest({
                        events: this._queue,
                        statsigMetadata: statsigMetadata,
                        time: Date.now(),
                    });
                    this._queue = [];
                }
                this._saveFailedRequests();
            }
            return;
        }
        var processor = this;
        this._network
            .postToEndpoint(StatsigNetwork_1.StatsigEndpoint.Rgstr, {
            events: oldQueue,
            statsigMetadata: statsigMetadata,
        }, 3 /* retries */, 1000 /* backoff */, isClosing /* useKeepalive */)
            .then(function (response) {
            if (!response.ok) {
                throw response;
            }
        })
            .catch(function (error) {
            if (typeof error.text === 'function') {
                error.text().then(function (errorText) {
                    _this._errorBoundary._logError(LOG_FAILURE_EVENT, error, function () { return __awaiter(_this, void 0, void 0, function () {
                        return __generator(this, function (_a) {
                            return [2 /*return*/, {
                                    eventCount: oldQueue.length,
                                    error: errorText,
                                }];
                        });
                    }); });
                });
            }
            else {
                _this._errorBoundary._logError(LOG_FAILURE_EVENT, error, function () { return __awaiter(_this, void 0, void 0, function () {
                    return __generator(this, function (_a) {
                        return [2 /*return*/, {
                                eventCount: oldQueue.length,
                                error: error.message,
                            }];
                    });
                }); });
            }
            processor._newFailedRequest(LOG_FAILURE_EVENT, oldQueue);
        })
            .finally(function () { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!isClosing) return [3 /*break*/, 2];
                        if (this._queue.length > 0) {
                            this._addFailedRequest({
                                events: this._queue,
                                statsigMetadata: statsigMetadata,
                                time: Date.now(),
                            });
                            // on app background/window blur, save unsent events as a request and clean up the queue (in case app foregrounds)
                            this._queue = [];
                        }
                        return [4 /*yield*/, processor._saveFailedRequests()];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        }); });
    };
    StatsigLogger.prototype.sendSavedRequests = function () {
        return __awaiter(this, void 0, void 0, function () {
            var failedRequests, fireAndForget, requestBodies, _loop_1, this_1, _i, requestBodies_1, requestBody;
            var _this = this;
            return __generator(this, function (_a) {
                fireAndForget = false;
                failedRequests = StatsigLocalStorage_1.default.getItem(Constants_1.STATSIG_LOCAL_STORAGE_LOGGING_REQUEST_KEY);
                if (failedRequests == null) {
                    this._clearLocalStorageRequests();
                    return [2 /*return*/];
                }
                if (failedRequests.length > MAX_LOCAL_STORAGE_SIZE) {
                    fireAndForget = true;
                }
                requestBodies = [];
                try {
                    requestBodies = JSON.parse(failedRequests);
                    _loop_1 = function (requestBody) {
                        if (requestBody != null &&
                            requestBody.events &&
                            Array.isArray(requestBody.events)) {
                            this_1._network
                                .postToEndpoint(StatsigNetwork_1.StatsigEndpoint.Rgstr, requestBody)
                                .then(function (response) {
                                if (!response.ok) {
                                    throw Error(response.status + '');
                                }
                            })
                                .catch(function (_e) {
                                if (fireAndForget) {
                                    return;
                                }
                                _this._addFailedRequest(requestBody);
                            });
                        }
                    };
                    this_1 = this;
                    for (_i = 0, requestBodies_1 = requestBodies; _i < requestBodies_1.length; _i++) {
                        requestBody = requestBodies_1[_i];
                        _loop_1(requestBody);
                    }
                }
                catch (_e) {
                }
                finally {
                    this._clearLocalStorageRequests();
                }
                return [2 /*return*/];
            });
        });
    };
    StatsigLogger.prototype._init = function () {
        var _this = this;
        if (typeof window !== 'undefined' &&
            typeof window.addEventListener === 'function') {
            window.addEventListener('blur', function () { return _this.flush(true); });
            window.addEventListener('beforeunload', function () { return _this.flush(true); });
            window.addEventListener('load', function () {
                setTimeout(function () { return _this.flush(); }, 100);
                setTimeout(function () { return _this.flush(); }, 1000);
            });
        }
        if (typeof document !== 'undefined' &&
            typeof document.addEventListener === 'function') {
            document.addEventListener('visibilitychange', function () {
                _this.flush(document.visibilityState !== 'visible');
            });
        }
        if (!this._options.ignoreWindowUndefined &&
            (typeof window === 'undefined' || window == null)) {
            // dont set the flush interval outside of client browser environments
            return;
        }
        if (this._options.localMode) {
            // unnecessary interval in local mode since logs dont flush anyway
            return;
        }
        var me = this;
        this._flushInterval = setInterval(function () {
            me.flush();
        }, this._options.loggingIntervalMillis);
        // Quick flush
        setTimeout(function () { return _this.flush(); }, 100);
        setTimeout(function () { return _this.flush(); }, 1000);
    };
    StatsigLogger.prototype._shouldLogExposure = function (key) {
        var lastTime = this._exposureDedupeKeys[key];
        var now = Date.now();
        if (lastTime == null) {
            this._exposureDedupeKeys[key] = now;
            return true;
        }
        if (lastTime >= now - 600 * 1000) {
            return false;
        }
        this._exposureDedupeKeys[key] = now;
        return true;
    };
    StatsigLogger.prototype._saveFailedRequests = function () {
        return __awaiter(this, void 0, void 0, function () {
            var requestsCopy;
            return __generator(this, function (_a) {
                if (this._failedLogEvents.length > 0) {
                    requestsCopy = JSON.stringify(this._failedLogEvents);
                    if (requestsCopy.length > MAX_LOCAL_STORAGE_SIZE) {
                        this._clearLocalStorageRequests();
                        return [2 /*return*/];
                    }
                    StatsigLocalStorage_1.default.setItem(Constants_1.STATSIG_LOCAL_STORAGE_LOGGING_REQUEST_KEY, requestsCopy);
                }
                return [2 /*return*/];
            });
        });
    };
    StatsigLogger.prototype._addFailedRequest = function (requestBody) {
        if (requestBody.time < Date.now() - MS_RETRY_LOGS_CUTOFF) {
            return;
        }
        if (this._failedLogEvents.length > MAX_BATCHES_TO_RETRY) {
            return;
        }
        var additionalEvents = requestBody.events.length;
        if (this._failedLogEventCount + additionalEvents > MAX_FAILED_EVENTS) {
            return;
        }
        this._failedLogEvents.push(requestBody);
        this._failedLogEventCount += additionalEvents;
    };
    StatsigLogger.prototype._clearLocalStorageRequests = function () {
        StatsigLocalStorage_1.default.removeItem(Constants_1.STATSIG_LOCAL_STORAGE_LOGGING_REQUEST_KEY);
    };
    StatsigLogger.prototype._newFailedRequest = function (name, queue) {
        if (this._loggedErrors.has(name)) {
            return;
        }
        this._loggedErrors.add(name);
        this._failedLogEvents.push({
            events: queue,
            statsigMetadata: this._identity._statsigMetadata,
            time: Date.now(),
        });
        this._saveFailedRequests().then(function () { });
    };
    return StatsigLogger;
}());
exports.default = StatsigLogger;
